import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";

// Components
import { AppMainComponent } from "src/app/app.main.component";

// Models
import { Account } from "src/app/accounts-v2/models/account.model";
import { Task } from "src/app/shared/model/task";

//  Services
import { ActivityService } from "../shared-activities/activity.service";
import { AppMainService } from "src/app/app-main.service";
import { StoreService } from "src/app/modules/shared/services/store.service";
import { TasksService } from "../../../../profile/tasks";
import { TaskType } from "../../enums/task.enum";
import { ContextMenuItem } from "src/app/accounts-v2/models/contextMenuItem.model";
import { IDateFilterModel } from "src/app/reports/models/reports-filter.models";

@Component({
    selector: 'app-lion-shared-task-listing',
    templateUrl: './shared-task-listing.component.html',
    styleUrls: ["./shared-task-listing.component.scss"],
})

export class LionSharedTaskListingComponent implements OnInit, OnChanges {
    @Input() selectedAccount: Account;
    @Input() objectTypeId: number;
    @Input() isSidebar: boolean = false;
    @Output() openAddTaskDialog: EventEmitter<any> = new EventEmitter<any>();

    tasksCols = [{ field: '', header: 'Tasks' }];
    tableShowMore: number[] = [15, 30, 50, 100];

    accountTasks: any[] = [];
    hasTasksLoaded: boolean = false;
    noTaskFindOrLoadingText: string = "";
    selectedTask: Task;

    //Task Add Edit
    displayAddTask: boolean = false;
    headerTitle: string;
    TaskType = TaskType;
    isAddTask: boolean = false;
    contextMenuItems: ContextMenuItem[] = [];
    isCopyTask: boolean = false;

    filterDataByTime: IDateFilterModel[] = [
        { label: 'All Tasks', code: 'all' },
        { label: 'Today', code: 'today' },
        { label: 'Yesterday', code: 'yesterday' },
        { label: 'This Month', code: 'this month' },
        { label: 'Last Month', code: 'last month' },
        { label: 'Last 7 days', code: 'last 7 days' },
        { label: 'Last 15 days', code: 'last 15 days' },
        { label: 'Last 30 days', code: 'last 30 days' },
        { label: 'Last 60 days', code: 'last 60 days' },
        { label: 'Last 90 days', code: 'last 90 days' },
        { label: 'Custom Date', code: 'custom' },
    ];
    dateFrom: Date = null;
    dateTo: Date = null;
    filteredEvents: any[] = [];
    selectedDateFilter: IDateFilterModel;

    constructor(
        private app: AppMainComponent,
        private appMainService: AppMainService,
        private activityService: ActivityService,
        private storeService: StoreService,
        private tasksService: TasksService)
    {}

    ngOnInit() {
        this.tasksService.taskCreateUpdate.subscribe(data => {
            this.hasTasksLoaded = false;
            this.loadTasksFromAPI();
        });

        this.tasksService.taskDelete$.subscribe(() => {
            this.reloadTaskiList();
        });
        this.selectedDateFilter = this.filterDataByTime[0];
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes?.selectedAccount?.currentValue){
            this.loadTasksFromStore();
            this.loadTasksFromAPI(true);
        }
        if(changes?.objectTypeId?.currentValue){
            this.objectTypeId = changes?.objectTypeId?.currentValue;
        }
    }

    loadTasksFromStore(): void {
        this.storeService.getTaskList()
            .subscribe(taskList => {
                this.accountTasks = taskList;
            });
    }

    loadTasksFromAPI(forceReload: boolean = false) {

        if ((!this.hasTasksLoaded && !this.accountTasks?.length) || forceReload) {
            this.noTaskFindOrLoadingText = 'Loading...';
            this.appMainService.isShowSpinner('getAllObjectTasks');
            this.activityService.getAllObjectTasks(this.selectedAccount.id, this.objectTypeId)
                .then((data: any[]) => {
                    const sortedTask:any[] = this.sortTasksByEndDateTime(data);
                    this.accountTasks = sortedTask || [];
                    this.hasTasksLoaded = true;
                    this.storeService.setTaskList(this.accountTasks);
                    this.appMainService.isHideSpinner('getAllObjectTasks');
                    this.noTaskFindOrLoadingText = this.filteredEvents?.length ? "Loading..." : "No Task Found...";
                    this.filterEvents();
                })
                .catch(() => {
                    this.noTaskFindOrLoadingText = 'No Task Found...';
                    this.appMainService.isHideSpinner('getAllObjectTasks');
                });
        }
    }

     onRowTaskSelect($event, rowSelect: boolean = false) {
        if(rowSelect){
            const { data: { taskId } } = $event;
            this.showTaskDetails(taskId);
        }else{
            this.showTaskDetails($event?.taskId)
        }
    }

    // Selecting a task from the task table
    showTaskDetails(taskId: any) {
        this.app.selectedTaskId = taskId;
        this.app.displayEditViewTask = true;
    }

    //tasks
    showAddTask() {
        this.headerTitle = 'Add New Task';
        this.displayAddTask = true;
        this.isAddTask = true;
    }

    cancelClicked(event) {
        this.displayAddTask = false;
        this.isCopyTask = false;
    }

    reloadTaskiList() {
        this.displayAddTask = false;
        this.hasTasksLoaded = false;
        this.loadTasksFromAPI(true);
    }

     // to check if assignTo is contains only digit
    isNumeric(value: string): boolean {
        return /^[0-9]+$/.test(value);
    }

    refreshData(){
        this.loadTasksFromAPI(true);
    }

    populateContextMenu() {
        this.contextMenuItems.push({
          label: 'View',
          icon: 'pi pi-list',
          command: () => {
            this.onRowTaskSelect(this.selectedTask, false);
          },
        });
        this.contextMenuItems.push({
          label: 'Copy Task',
          icon: 'pi pi-copy',
          command: () => {
            this.copyTask(this.selectedTask);
          }
        });
      }

      copyTask(selectedTask) {
        this.headerTitle = 'Copy Task';
        this.displayAddTask = true;
        this.isCopyTask = true;
        this.selectedTask = selectedTask?.taskId;
      }

    getAssignedUserIndex(rowData: any): number {
        const index = rowData?.assignedUser?.findIndex(user => user.isLoginUser);
        return index >= 0 ? index : 0;
    }

    getReassignedUserIndex(rowData: any): number {
        const index = rowData?.reassignUser?.findIndex(user => user.isLoginUser);
        return index >= 0 ? index : 0;
    }

    sortTasksByEndDateTime(tasks: any[]): any[] {
        if (!tasks || !tasks?.length) {
          return [];
        }
        return tasks.sort((a, b) => {
          const endDateA = new Date(a?.task?.endDateTime).getTime();
          const endDateB = new Date(b?.task?.endDateTime).getTime();
          return endDateA - endDateB; // Ascending order
        });
      }

    //#region filter

    onFilterChange(event: any) {
        if (!event?.value) return;
        
        this.selectedDateFilter = event.value;
        if (this.selectedDateFilter.code !== 'custom') {
          this.dateFrom = null;
          this.dateTo = null;
        }
        this.filterEvents();
      }
    
      onCustomDateChange() {
        if (this.selectedDateFilter?.code === 'custom' && this.dateFrom && this.dateTo) {
          this.filterEvents();
        }
      }
    
      resetFilter(event): void {
        // Reset to 'All Events' filter
        this.selectedDateFilter = null;
        this.dateFrom = null;
        this.dateTo = null;
        this.selectedDateFilter = { ...this.filterDataByTime[0] };
        this.filterEvents();
      }
    
      filterEvents() {
        if (!this.accountTasks || !this.selectedDateFilter) {
          this.filteredEvents = [];
          this.noTaskFindOrLoadingText = !this.filteredEvents?.length ? "No Task Found..." : "";
          return;
        }
    
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        // If 'all' is selected, show all events
        if (this.selectedDateFilter.code === 'all') {
          this.filteredEvents = [...this.accountTasks];
          return;
        }
    
        this.filteredEvents = this.accountTasks.filter(a => {
          // Create a new Date object for comparison and set to midnight
          const taskDate = new Date(a.task.endDateTime);
          taskDate.setHours(0, 0, 0, 0);
    
          switch (this.selectedDateFilter.code) {
            case 'today': {
              return this.isSameDay(taskDate, today);
            }
            
            case 'yesterday': {
              const yesterday = new Date(today);
              yesterday.setDate(today.getDate() - 1);
              return this.isSameDay(taskDate, yesterday);
            }
            
            case 'this month': {
              return taskDate.getMonth() === today.getMonth() && 
                    taskDate.getFullYear() === today.getFullYear();
            }
            
            case 'last month': {
              const lastMonth = new Date(today);
              lastMonth.setMonth(today.getMonth() - 1);
              return taskDate.getMonth() === lastMonth.getMonth() && 
                    taskDate.getFullYear() === lastMonth.getFullYear();
            }
            
            case 'last 7 days': {
              const last7Days = new Date(today);
              last7Days.setDate(today.getDate() - 7);
              return taskDate >= last7Days && taskDate <= today;
            }
            
            case 'last 15 days': {
              const last15Days = new Date(today);
              last15Days.setDate(today.getDate() - 15);
              return taskDate >= last15Days && taskDate <= today;
            }
            
            case 'last 30 days': {
              const last30Days = new Date(today);
              last30Days.setDate(today.getDate() - 30);
              return taskDate >= last30Days && taskDate <= today;
            }
            
            case 'last 60 days': {
              const last60Days = new Date(today);
              last60Days.setDate(today.getDate() - 60);
              return taskDate >= last60Days && taskDate <= today;
            }
            
            case 'last 90 days': {
              const last90Days = new Date(today);
              last90Days.setDate(today.getDate() - 90);
              return taskDate >= last90Days && taskDate <= today;
            }
            
            case 'custom': {
              if (!this.dateFrom || !this.dateTo) return true;
              
              const fromDate = new Date(this.dateFrom);
              const toDate = new Date(this.dateTo);
              fromDate.setHours(0, 0, 0, 0);
              toDate.setHours(23, 59, 59, 999);
              
              return taskDate >= fromDate && taskDate <= toDate;
            }
            
            default:
              return true;
          }
        });
        this.noTaskFindOrLoadingText = !this.filteredEvents?.length ? "No Task Found..." : "";
      }
    
      private isSameDay(date1: Date, date2: Date): boolean {
        return date1.getFullYear() === date2.getFullYear() &&
              date1.getMonth() === date2.getMonth() &&
              date1.getDate() === date2.getDate();
      }
}
